import RestaurantsList, {
  IRestaurant
} from "Models/ReduxModels/RestaurantCoffeeModel";
import mockData from "./restaurant.json";
import FilteredRestaurants from "Models/ReduxModels/FilteredRestaurants";
import ApplicationFlag from "Models/ReduxModels/ApplicationFlag";
import { spring } from "react-motion";

export const restaurantServiceCall = filterText => {
  let mock = true;
  return new Promise((resolve, reject) => {
    if (mock) {
      let list: any = mockData.data.restaurantlist;
      if (list.length) {
        resolve(list);
      } else {
        reject(new Error("Mock response error!!"));
      }
    } else {
      let postData = {
        method: "POST",
        body: JSON.stringify({
          searchString: filterText
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      };
      fetch(
        "https://api.staging.diningclubgroup.com/restaurant-service-api/v2.40/restaurant?offset=0&limit=100",
        postData
      )
        .then(response => response.json())
        .then(data => {
          if (data) {
            resolve(data);
          } else {
            reject(new Error("API Error!!"));
          }
        })
        .catch(error => reject(new Error("API Error!!")));
    }
  });
};

export const setRestaurantListInitial = list => {
  let newObj = {};
  if (list.length) {
    list.map((item: any) => {
      let restaurant: IRestaurant = {
        id: item.id,
        type: item.type,
        name: item.name,
        cuisines: item.cuisines,
        chain: item.chain,
        independent: item.independent,
        brand: item.brand,
        images: item.images,
        website: item.website,
        description: item.description,
        notice: item.notice,
        bookingTelephone: item.bookingTelephone,
        bookingEmail: item.bookingEmail,
        bookingUrl: item.bookingUrl,
        isBookingRequired: item.isBookingRequired,
        offers: item.offers,
        address: item.address,
        geo: item.geo,
        updatedAt: item.updatedAt,
        deletedAt: item.deletedAt,
        newUntil: item.newUntil,
        ctas: item.ctas,
        primaryImage: item.primaryImage
      };
      newObj[item?.id] = restaurant;
    });
  }

  new RestaurantsList({
    id: "",
    ...newObj
  }).$save();
};

export const redirecttoHomeUpdateStore = () => {
  let applicationFlags = ApplicationFlag.getInsatnce("")?.props;
  // let restaurantList = IRestoCoffeeModel.getInsatnce("")?.props;
  // let filterDetails = RestoLocalBFilterModal.getInsatnce("")?.props;
  let filteredRestaurants = FilteredRestaurants.getInsatnce("")?.props;
  // let list = {};
  // new RestoLocalBFilterModal({
  //   id: "",
  //   ...filterDetails
  // }).$deleteInstance();

  // new IRestoCoffeeModel ({
  //   id: "",
  //   ...list
  // }).$save()
  new FilteredRestaurants({
    id: "",
    ...filteredRestaurants
  }).$deleteInstance();
  new ApplicationFlag({
    id: "",
    ...applicationFlags,
    isShowFooter: true,
    isRedirectedFromGiftingSuccessPage: false,
    eatLocalCoffeClubID: 0,
    eatLocalCoffeClubOffer: {},
    selectedShopOrResto: {}
  }).$save();
};

export const titleDefaultStyles = {
  opacity: 0,
  marginTop: -40
};

export const titleEnterStyles = {
  marginTop: spring(0),
  opacity: spring(1)
};

export const titleLeaveStyles = {
  marginTop: spring(-40),
  opacity: spring(0)
};
